import { ref } from 'vue';

// Only show the bar if navigation is still in progress after this delay.
// Fast/cached navigations finish before it fires → bar never appears, no blink.
const SHOW_DELAY_MS = 150;

// Duration of the "finish" fade. MUST match the `opacity` transition in
// RouteProgressBar.vue: the bar fills to 100% + fades, and only after that do we reset
// it to width 0 — otherwise the next navigation starts mid-fade / slides backwards.
const FINISH_FADE_MS = 300;

const isActive = ref(false);
const isFinishing = ref(false);
let showTimer: ReturnType<typeof setTimeout> | undefined;
let resetTimer: ReturnType<typeof setTimeout> | undefined;

export function useNavigationProgress() {
  function start() {
    if (showTimer) clearTimeout(showTimer);
    if (resetTimer) clearTimeout(resetTimer);
    isFinishing.value = false;
    isActive.value = false;
    showTimer = setTimeout(() => {
      isActive.value = true; // bar creeps 0 → 90% (CSS keyframe)
    }, SHOW_DELAY_MS);
  }

  function done() {
    if (showTimer) {
      clearTimeout(showTimer); // nav finished before show delay — never show
      showTimer = undefined;
    }
    if (!isActive.value) return;
    isFinishing.value = true; // bar fills → 100% + fades (CSS)
    resetTimer = setTimeout(() => {
      // wait out the fade, THEN reset for next nav
      isActive.value = false;
      isFinishing.value = false;
    }, FINISH_FADE_MS);
  }

  return { isActive, isFinishing, start, done };
}
